// extracted by mini-css-extract-plugin
module.exports = {"ingredientForm":"ingredient-form_ingredientForm__qz7Ro","formContainer":"ingredient-form_formContainer__4oFWC"};